import _FunnelIcon from "@adsk/alloy-react-icon/es/lib/FunnelIcon";
import _XCircleFilledIcon from "@adsk/alloy-react-icon/es/lib/XCircleFilledIcon";
import _styled from "styled-components";
const _excluded = ["style", "className", "filtersOpen", "toggleFiltersPanel", "filtersCount", "clearFilters", "customFilterText", "customClearFilterText", "minimized", "disabled", "renderFilterButtonText", "renderFilterButtonIcon"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import Button from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import Tooltip from '@adsk/alloy-react-tooltip';
const buttonStyles = {
  '&:hover': {
    boxShadow: 'none'
  },
  '&:focus': {
    boxShadow: theme.halos.focus
  },
  '&:active': {
    boxShadow: theme.halos.active
  },
  '&[disabled]': {
    borderColor: theme.tokens.colors.border.inactive.value,
    color: theme.tokens.colors.text.inactive.value,
    '&:hover': {
      background: theme.tokens.colors.background.primary.value
    },
    '&:active': {
      boxShadow: 'none'
    }
  }
};
const renderXIcon = p => /*#__PURE__*/React.createElement(_XCircleFilledIcon, p);
const getFilterButtonText = _ref => {
  let {
    filtersCount,
    minimized,
    customFilterText,
    T
  } = _ref;
  if (!filtersCount) {
    return null;
  }
  if (minimized) {
    return "(".concat(filtersCount, ")");
  }
  return customFilterText || T.translate('FILTER_INDICATOR', {
    count: filtersCount
  });
};

/**
 * Filter Button.
 * Used to handle filters panel state.
 */
const FilterButton = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
      style,
      className,
      filtersOpen,
      toggleFiltersPanel,
      filtersCount,
      clearFilters,
      customFilterText,
      customClearFilterText,
      minimized,
      disabled,
      renderFilterButtonText = getFilterButtonText,
      renderFilterButtonIcon = _FunnelIcon.renderIcon
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  const {
    T
  } = useLocale(_ref3 => {
    let {
      locale
    } = _ref3;
    return require("./i18n/".concat(locale, ".json"));
  });
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({
    ref: ref,
    className: className
  }, props, {
    $_css: [_objectSpread({
      display: 'inline-flex',
      alignItems: 'center',
      borderRadius: theme.borderRadius.small,
      transition: theme.transitions.create(['box-shadow', 'border'])
    }, !disabled && {
      '&:hover': {
        boxShadow: theme.halos.hover
      }
    }), style]
  }), /*#__PURE__*/React.createElement(Button, {
    renderIcon: renderFilterButtonIcon,
    selected: filtersOpen,
    onClick: toggleFiltersPanel,
    disabled: disabled,
    style: [_objectSpread(_objectSpread({}, filtersCount && {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    }), {}, {
      fontVariantNumeric: 'tabular-nums'
    }, !filtersOpen && {
      '&:hover': {
        background: theme.tokens.colors.background.neutral.hover.value
      }
    }), buttonStyles]
  }, renderFilterButtonText({
    filtersCount,
    minimized,
    customFilterText,
    T
  })), Boolean(filtersCount) && /*#__PURE__*/React.createElement(Tooltip, {
    content: disabled ? '' : customClearFilterText || T.translate('CLEAR_ALL_FILTERS'),
    placement: Tooltip.PLACEMENTS.TOP_END
  }, /*#__PURE__*/React.createElement(Button, {
    renderIcon: renderXIcon,
    onClick: clearFilters,
    disabled: disabled,
    style: [_objectSpread({
      width: 36,
      height: 36,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      borderLeft: 0
    }, !filtersOpen && {
      '&:hover': {
        background: theme.tokens.colors.background.neutral.hover.value,
        color: theme.tokens.colors.text.primary.value
      }
    }), buttonStyles]
  })));
});
FilterButton.displayName = 'FilterButton';
FilterButton.propTypes = {
  /**
   * Styles applied to the root element
   */
  style: stylePropType,
  /**
   * Class applied to the root element
   */
  className: PropTypes.string,
  /**
   * Whether or not filter panel is open.
   */
  filtersOpen: PropTypes.bool.isRequired,
  /**
   * Callback to toggle filter panel open/close.
   */
  toggleFiltersPanel: PropTypes.func.isRequired,
  /**
   * Callback to clear filters.
   */
  clearFilters: PropTypes.func.isRequired,
  /**
   * Number of active filters.
   */
  filtersCount: PropTypes.number,
  /**
   * Whether the button in minimized mode.
   */
  minimized: PropTypes.bool,
  /**
   * Disable button functionality
   */
  disabled: PropTypes.bool,
  /**
   * Custom filter text overwrite
   */
  customFilterText: PropTypes.any,
  /**
   * Custom the tooltip text for the clear filter button
   */
  customClearFilterText: PropTypes.any,
  /**
   * Render props to generate filter text
   */
  renderFilterButtonText: PropTypes.func,
  /**
   * Render props to render filter button icon
   */
  renderFilterButtonIcon: PropTypes.func
};
export default FilterButton;
var _StyledDiv = _styled("div").withConfig({
  displayName: "FilterButton___StyledDiv",
  componentId: "sc-a1k4fx-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=FilterButton.js.map